import { render, staticRenderFns } from "./AdminVideo.vue?vue&type=template&id=0b4c79b3&scoped=true"
import script from "./AdminVideo.vue?vue&type=script&lang=js"
export * from "./AdminVideo.vue?vue&type=script&lang=js"
import style0 from "./AdminVideo.vue?vue&type=style&index=0&id=0b4c79b3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c79b3",
  null
  
)

export default component.exports